module.exports = __webpack_public_path__ + "img/dep_candyandgum.e0e58d8f.png";